"use client"

import { BugOff } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BugOffIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BugOffIcon = component(Icon)({ as: BugOff })
